/** Куда человек ходил в витрине.
 *
 * Каталог уезжает к клиенту целиком и листается уже там — сервер сам по себе
 * не знает, что человек смотрел. Сообщаем об этом отдельной короткой запиской:
 * ответа не ждём, ошибку глотаем. Статистика не стоит того, чтобы из-за неё
 * замирал переход между экранами.
 */
import { request } from '@/shared/api';

type Kind = 'menu' | 'list' | 'product' | 'search' | 'account' | 'cart';

/** Один и тот же экран подряд не считаем: это возврат, а не новый заход. */
let last = '';

export function track(kind: Kind, id: string, title = ''): void {
  const key = `${kind}:${id}`;
  if (key === last) return;
  last = key;
  request('/api/track', { kind, id, title }).catch(() => undefined);
}
